export default __webpack_public_path__ + "static/media/img_demo_02_m.6a55b72e.webp";